const API_MESSAGE_SEND_REQUEST = 'API_MESSAGE_SEND_REQUEST';
const API_MESSAGE_SEND_SUCCESS = 'API_MESSAGE_SEND_SUCCESS';
const API_MESSAGE_SEND_FAILURE = 'API_MESSAGE_SEND_FAILURE';

const MESSAGE_STATUS_ACTION = 'MESSAGE_STATUS_ACTION';
const CHANGE_MESSAGE_TYPE = 'CHANGE_MESSAGE_TYPE';

const API_UPDATE_MESSAGE_STATUS_REQUEST = 'API_UPDATE_MESSAGE_STATUS_REQUEST';
const API_UPDATE_MESSAGE_STATUS_SUCCESS = 'API_UPDATE_MESSAGE_STATUS_SUCCESS';
const API_UPDATE_MESSAGE_STATUS_FAILURE = 'API_UPDATE_MESSAGE_STATUS_FAILURE';

const API_UPDATE_ANNOUNCEMENT_STATUS_REQUEST = 'API_UPDATE_MESSAGE_ANNOUNCEMENT_REQUEST';
const API_UPDATE_ANNOUNCEMENT_STATUS_SUCCESS = 'API_UPDATE_MESSAGE_ANNOUNCEMENT_SUCCESS';
const API_UPDATE_ANNOUNCEMENT_STATUS_FAILURE = 'API_UPDATE_MESSAGE_ANNOUNCEMENT_FAILURE';

const ADD_ATTACHMENT = 'ADD_ATTACHMENT';
const REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT';
const RESET_MESSAGE = 'RESET_MESSAGE';

export const resetMessage = () => ({
  type: RESET_MESSAGE,
});

export const changeMessageType = payload => ({
  type: CHANGE_MESSAGE_TYPE,
  payload,
});

export const removeAttachment = () => ({
  type: REMOVE_ATTACHMENT,
});

export const addAttachment = payload => ({
  type: ADD_ATTACHMENT,
  payload,
});

export const messageSendRequest = payload => ({
  type: API_MESSAGE_SEND_REQUEST,
  payload,
});

export const messageSendSuccess = payload => ({
  type: API_MESSAGE_SEND_SUCCESS,
  payload,
});

export const messageSendFailure = payload => ({
  type: API_MESSAGE_SEND_FAILURE,
  payload,
});

export const updateMessageStatusRequest = () => ({
  type: API_UPDATE_MESSAGE_STATUS_REQUEST,
});

export const updateMessageStatusSuccess = payload => ({
  type: API_UPDATE_MESSAGE_STATUS_SUCCESS,
  payload,
});

export const updateMessageStatusFailure = payload => ({
  type: API_UPDATE_MESSAGE_STATUS_FAILURE,
  payload,
});

export const updateAnnouncementStatusRequest = () => ({
  type: API_UPDATE_ANNOUNCEMENT_STATUS_REQUEST,
});

export const updateAnnouncementStatusSuccess = payload => ({
  type: API_UPDATE_ANNOUNCEMENT_STATUS_SUCCESS,
  payload,
});

export const updateAnnouncementStatusFailure = payload => ({
  type: API_UPDATE_ANNOUNCEMENT_STATUS_FAILURE,
  payload,
});

export const messageStatusAction = payload => ({
  type: MESSAGE_STATUS_ACTION,
  payload,
});

const initialState = {
  attachment: null,
  messageSent: false,
  messageData: null,
  isFetched: false,
  fetching: false,
  error: null,
  message: null,
  statusAction: null,
  typeId: 1,
};

export function messageReducer(state = initialState, action) {
  switch (action.type) {
    case REMOVE_ATTACHMENT:
      
      return {
        ...state,
        attachment: null,
      };
    case RESET_MESSAGE:
      return {
        ...initialState,
      };
    case CHANGE_MESSAGE_TYPE:
      return {
        ...state,
        typeId: action.payload,
      };
    case ADD_ATTACHMENT:
      
      return {
        ...state,
        attachment: action.payload,
      };
    case API_MESSAGE_SEND_REQUEST:
      return {
        ...state,
        fetching: true,
        messageData: action.payload,
      };
    case API_MESSAGE_SEND_SUCCESS:
      
      return {
        ...state,
        fetching: false,
        isFetched: true,
        messageSent: true,
        messageData: {
          ...state.messageData,
          ...action.payload,
        },
        attachment: null,
      };
    case API_MESSAGE_SEND_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    case API_UPDATE_MESSAGE_STATUS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_UPDATE_MESSAGE_STATUS_SUCCESS:
      return {
        ...state,
        fetching: false,
      };
    case API_UPDATE_MESSAGE_STATUS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case API_UPDATE_ANNOUNCEMENT_STATUS_REQUEST:
          return {
            ...state,
            fetching: true,
          };
    case API_UPDATE_ANNOUNCEMENT_STATUS_SUCCESS:
          return {
            ...state,
            fetching: false,
          };
    case API_UPDATE_ANNOUNCEMENT_STATUS_FAILURE:
          return {
            ...state,
            error: action.payload,
          };
    case MESSAGE_STATUS_ACTION:
      return {
        ...state,
        statusAction: action.payload,
        
      };
    default:
      return state;
  }
}
